import { motion, useScroll, useTransform } from 'framer-motion';
import { useMemo } from 'react';

interface BlueprintGridProps {
  className?: string;
}

export function BlueprintGrid({ className = '' }: BlueprintGridProps) {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1200], [0, -40]);
  const subtleOpacity = useMemo(() => 0.03, []);

  return (
    <motion.div 
      className={`absolute inset-0 pointer-events-none will-change-transform ${className}`}
      style={{
        y,
        backgroundImage: `
          linear-gradient(to right, hsl(var(--primary) / ${subtleOpacity}) 1px, transparent 1px),
          linear-gradient(to bottom, hsl(var(--primary) / ${subtleOpacity}) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
      }}
    >
      {/* Larger grid overlay for architectural feel */}
      <motion.div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(to right, hsl(var(--accent) / 0.02) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(var(--accent) / 0.02) 1px, transparent 1px)
          `,
          backgroundSize: '100px 100px',
        }}
      />
    </motion.div>
  );
}
